export default {
  streamings: [],
  pagination: {},
  streaming: {}
}
